/* CSS */
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "../css/site.css";

// JS
import * as CookieConsent from 'vanilla-cookieconsent';
import Lenis from 'lenis';

// Alpine Objects
import "./components/app";
import Alpine from "alpinejs";
import collapse from '@alpinejs/collapse'

// import masonry
import MasonryGrid from "./components/masonry";

// UTM tracking
import "./components/utm-tracker";


// ----------------------------------------------------------------

function updateGtagConsent() {
    let consentPreferences = {
        'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        'ad_storage': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        'ad_user_data': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        'ad_personalization': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
    };


    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }

    gtag('consent', 'update', consentPreferences)

    window.dataLayer.push({
        event: 'consentUpdateEvent', // Your custom event name for GTM
        consentUpdateState: consentPreferences
    });

    // For debugging purposes, you can log this to the console:
    console.log('Custom consent event pushed to dataLayer:', {
        event: 'consentUpdateEvent',
        consentUpdateState: consentPreferences
    });
}



window.CookieConsentConfig = {
    cookie: {
        name: 'cc_cookie',
    },
    categories: {
        necessary: {
            readOnly: true,
            enabled: true
        },
        analytics: {
        },
        marketing: {
        }
    },
    // guiOptions: {
    //     consentModal: {
    //         layout: 'box inline',
    //         position: 'bottom center',
    //     },
    // },
    hideFromBots: true,
    disablePageInteraction: true,
    autoShow: !document.querySelector('body').classList.contains('privacy-policy'),
    guiOptions: {
        consentModal: {
            layout: 'box wide',
            position: 'middle center',
            equalWeightButtons: false,
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
        }
    },

    onFirstConsent: () => {
        console.log("onFirstConsent");
        // updateGtagConsent();
    },
    onConsent: () => {
        console.log("onConsent");
        updateGtagConsent();
    },
    onChange: () => {
        console.log("onChange");
        updateGtagConsent();
    },

    language: {
        default: 'nl',

        translations: {
            nl: {
                consentModal: {
                    title: 'Deze website maakt gebruik van cookies',
                    description: 'We gebruiken cookies om uw ervaring te verbeteren, websiteverkeer te analyseren en gepersonaliseerde inhoud te leveren. <a class=\"cc-link\" href=\"/cookiebeleid\">Cookiebeleid</a>.',
                    acceptAllBtn: 'Oke',
                    // acceptNecessaryBtn: 'Afwijzen',
                    showPreferencesBtn: "Aanpassen",
                    // footer: `
                    //     <a href="#link">Privacy Policy</a>
                    // `
                },
                preferencesModal: {
                    title: 'Cookie voorkeuren',
                    acceptAllBtn: 'Alle toestaan',
                    // acceptNecessaryBtn: 'Alle afwijzen',
                    savePreferencesBtn: "Opslaan",
                    serviceCounterLabel: "Service|Services",
                    closeIconLabel: 'Sluiten',
                    sections: [
                        {
                            // title: 'Cookie usage',
                            description: "We gebruiken cookies om uw ervaring te verbeteren, websiteverkeer te analyseren en gepersonaliseerde inhoud te leveren."
                        },
                        {
                            title: "Strict noodzakelijke cookies",
                            description: "Noodzakelijke cookies helpen een website bruikbaarder te maken, door basisfuncties als paginanavigatie en toegang tot beveiligde gedeelten van de website mogelijk te maken. Zonder deze cookies kan de website niet naar behoren werken.",
                            linkedCategory: "necessary",
                            cookieTable: {
                                caption: "Cookie table",
                                headers: {
                                    name: "Naam",
                                    // domain: "Domein",
                                    description: "Beschrijving",
                                    expiration: "Verloopdatum"
                                },
                                body: [{
                                    name: "CraftSessionId",
                                    expiration: "Session",
                                    description: "Deze website maakt gebruik van PHP sessies om sessies over webverzoeken te onderhouden. Dit gebeurt via de PHP sessiecookie.",
                                    is_regex: !0
                                }, {
                                    name: "CRAFT_CSRF_TOKEN",
                                    expiration: "Session",
                                    description: "Beschermt ons en u als gebruiker tegen Cross-Site Request Forgery aanvallen."
                                }, {
                                    name: "cc_cookie",
                                    expiration: "6 maanden",
                                    description: 'Deze cookie bepaalt of een gebruiker de pop-up al gezien en weggeklikt heeft. Indien deze cookie niet geplaatst is, zal de pop-up getoond worden.',
                                }, {
                                    name: "nd_utm_*",
                                    expiration: "30 dagen",
                                    description: "Deze cookies slaan de advertentiecampagne-informatie op (bron, medium, campagne, zoekwoord, advertentievariant, landingspagina en klik-ID's van Google en Meta) van de pagina waarop u onze website heeft bezocht. Ze worden uitsluitend gebruikt voor interne rapportage over welke campagnes leads opleveren.",
                                    is_regex: !0
                                }]
                            }
                        },
                        {
                            title: "Statistische Cookies",
                            description: "Statistische cookies helpen eigenaren van websites begrijpen hoe bezoekers hun website gebruiken, door anoniem gegevens te verzamelen en te rapporteren.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Marketing Cookies",
                            description: "Marketingcookies worden gebruikt om bezoekers te volgen wanneer ze verschillende websites bezoeken. Hun doel is advertenties weergeven die zijn toegesneden op en relevant zijn voor de individuele gebruiker. Deze advertenties worden zo waardevoller voor uitgevers en externe adverteerders.",
                            linkedCategory: "marketing"
                        },
                        // {
                        //     title: 'More information',
                        //     description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc__link" href="#yourdomain.com">contact me</a>.',
                        // }
                    ]
                }
            }
        }
    }
}
window.CookieConsent = CookieConsent;


const lenis = new Lenis();
window.lenis = lenis;
function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}
requestAnimationFrame(raf)

// Lock/unlock page scroll (used by drawers/modals)
let scrollLockCount = 0;
window.lockPageScroll = () => {
    scrollLockCount++;
    if (scrollLockCount === 1) {
        lenis.stop();
        document.documentElement.classList.add('is-scroll-locked');
    }
};
window.unlockPageScroll = () => {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
        lenis.start();
        document.documentElement.classList.remove('is-scroll-locked');
    }
};

let scrollTo = document.querySelectorAll('[data-scroll-to]');

scrollTo.forEach(element => {
    element.addEventListener('click', (e) => {
        e.preventDefault();
        let target = element.getAttribute('data-scroll-to');
        lenis.scrollTo(target);
    });
});

// Links to the quote page scroll to the quote form when it is on the current page.
// Without the form on the page they stay ordinary links to /offerte. The quote
// form is the first form block marked data-quote-form (form.twig); links inside
// that block itself always stay ordinary links.
const QUOTE_PATH = '/offerte';
const QUOTE_SCROLL_CORRECTIONS = 3;
// Beyond this many viewport heights we jump most of the way and glide the rest
const QUOTE_JUMP_VIEWPORTS = 2;
// The mobile menu slides out in 300ms (header.twig); scroll after that plus a short pause
const QUOTE_AFTER_DRAWER_DELAY = 450;
const quoteForm = document.querySelector('[data-quote-form]');

const easeInOutCubic = t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

// Seconds for a smooth scroll over `distance` px: 0.8s per viewport, within 0.6–1.2s
function quoteScrollDuration(distance) {
    return Math.min(1.2, Math.max(0.6, 0.4 + 0.4 * (distance / window.innerHeight)));
}

// Short distances scroll smoothly. Long ones jump to one viewport before the
// form and glide the last stretch, instead of racing through the whole page.
// Lenis fixes the target when a scroll starts, and images that load on the way
// can still move the form, so after arriving we measure again and correct.
// `quote-scroll-start` / `quote-scroll-end` let the call bar hold still meanwhile.
function scrollToQuoteForm(attempt = 0) {
    const margin = parseFloat(getComputedStyle(quoteForm).scrollMarginTop) || 0;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const targetOf = () => quoteForm.getBoundingClientRect().top + lenis.scroll - margin;
    let glide = false;

    if (attempt === 0) {
        window.dispatchEvent(new CustomEvent('quote-scroll-start'));

        const distance = targetOf() - lenis.scroll;
        if (!reducedMotion && Math.abs(distance) > window.innerHeight * QUOTE_JUMP_VIEWPORTS) {
            lenis.scrollTo(targetOf() - Math.sign(distance) * window.innerHeight, { immediate: true, force: true });
            glide = true;
        }
    }

    lenis.scrollTo(quoteForm, {
        offset: -margin,
        immediate: reducedMotion,
        force: true,
        duration: quoteScrollDuration(Math.abs(targetOf() - lenis.scroll)),
        easing: glide ? easeOutCubic : easeInOutCubic,
        onComplete: () => {
            const drift = quoteForm.getBoundingClientRect().top - margin;
            const atBottom = lenis.scroll >= lenis.limit - 1;

            if (Math.abs(drift) > 2 && !(atBottom && drift > 0) && attempt < QUOTE_SCROLL_CORRECTIONS) {
                // Let Lenis pick up the new page height before correcting
                requestAnimationFrame(() => {
                    lenis.resize();
                    scrollToQuoteForm(attempt + 1);
                });
                return;
            }

            quoteForm
                .querySelector('input:not([type="hidden"]), select, textarea')
                ?.focus({ preventScroll: true });
            window.dispatchEvent(new CustomEvent('quote-scroll-end'));
        },
    });
}

if (quoteForm) {
    document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.closest('[data-quote-form]')) return;
        if (new URL(link.href, window.location.href).pathname.replace(/\/$/, '') !== QUOTE_PATH) return;

        event.preventDefault();
        history.pushState(null, '', `#${quoteForm.id}`);

        // An open drawer (mobile menu) locks scrolling. Close it first and let it
        // finish sliding out before scrolling, so the two movements stay apart.
        const drawerOpen = scrollLockCount > 0;
        window.dispatchEvent(new CustomEvent('close-drawers'));

        if (drawerOpen) {
            setTimeout(() => requestAnimationFrame(() => scrollToQuoteForm()), QUOTE_AFTER_DRAWER_DELAY);
        } else {
            requestAnimationFrame(() => scrollToQuoteForm());
        }
    });
}


function masonryGrid() {
    const element = document.querySelector('.js-masonry');
    if (!!element) {
        element.classList.add('masonry-grid');

        // Get default value from data-columns-default attribute
        const defaultColumns = element.getAttribute('data-columns-default');

        const masonryGrid = new MasonryGrid(
            element,
            {
                '900': 2,
                '1200': 3,
                // only provide the default-property if defaultColumns is set in the data-columns-default attribute
                'default': defaultColumns ? defaultColumns : 4
            },
            {
                useViewportWidth: true,
                balanceThreshold: 100, // Adjust this value to change sensitivity of balancing
            }
        );
    }
}




// Start Alpine
Alpine.plugin(collapse);
window.Alpine = Alpine;
Alpine.start();

// DOM ready
document.addEventListener('DOMContentLoaded', () => {
    masonryGrid();
});